import { Cell, Grid, HeadingSection, InfoLabel } from 'bold-ui'
import { booleanToSimNaoTitleCase } from 'components/form'
import { Endereco } from 'graphql/types.generated'
import React from 'react'
import { PAIS_BRASIL } from 'view/cidadao/createfci/model-cidadaoFci'

interface CidadaoFciEnderecoSectionProps {
  endereco: Endereco
  statusSituacaoDeRua?: boolean
  paisResidencia?: string
  localidadeExterior?: string
}

export const CidadaoFciEnderecoSection = (props: CidadaoFciEnderecoSectionProps) => {
  const { endereco, statusSituacaoDeRua, paisResidencia, localidadeExterior } = props
  return (
    <HeadingSection level={2} title='Endereço'>
      <Grid wrap>
        <Cell size={4}>
          <InfoLabel title='País de residência'>{paisResidencia?.titleCase()}</InfoLabel>
        </Cell>
        {paisResidencia === undefined || paisResidencia === PAIS_BRASIL.nome ? (
          <>
            <Cell size={8}>
              <InfoLabel title='CEP'>{endereco?.cep}</InfoLabel>
            </Cell>
            <Cell size={4}>
              <InfoLabel title='Estado'>{endereco?.uf?.nome?.titleCase()}</InfoLabel>
            </Cell>
            <Cell size={4}>
              <InfoLabel title='Município'>{endereco?.municipio?.nome?.titleCase()}</InfoLabel>
            </Cell>
            <Cell size={4}>
              <InfoLabel title='Bairro'>{endereco?.bairro?.titleCase()}</InfoLabel>
            </Cell>
            <Cell size={4}>
              <InfoLabel title='Tipo de logradouro'>{endereco?.tipoLogradouro?.nome?.titleCase()}</InfoLabel>
            </Cell>
            <Cell size={4}>
              <InfoLabel title='Logradouro'>{endereco?.logradouro?.titleCase()}</InfoLabel>
            </Cell>
            <Cell size={4}>
              <InfoLabel title='Número'>{endereco?.numero}</InfoLabel>
            </Cell>
            <Cell size={4}>
              <InfoLabel title='Complemento'>{endereco?.complemento?.titleCase()}</InfoLabel>
            </Cell>
            <Cell size={4}>
              <InfoLabel title='Ponto de referência'>{endereco?.pontoReferencia?.titleCase()}</InfoLabel>
            </Cell>
          </>
        ) : (
          <Cell size={4}>
            <InfoLabel title='Município de residência'>{localidadeExterior?.titleCase()}</InfoLabel>
          </Cell>
        )}
        <Cell size={4}>
          <InfoLabel title='Está em situação de rua'>{booleanToSimNaoTitleCase(statusSituacaoDeRua)}</InfoLabel>
        </Cell>
      </Grid>
    </HeadingSection>
  )
}
